function mobilecheck() {
    var check = false;
    (function (a) { if (/(android|ipad|playbook|silk|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}

window.mevent = "";

if (mobilecheck()) {
    window.mevent = "touch";
}
else {
    window.mevent = "click";
}

$(function () {
    var $html = $('html');
    var $body = $('body');
    var $wrap = $('#wrap');
    var $rndoverlay = $('#rnd-mobile-overlay');

    $('body').on('click touch touchend', '#left-menu', function (e) {
        e.stopPropagation();
        e.preventDefault();
        var $this = $(this);
        pageup();
        var $rndmenu = $('#rnd-mobile-menu');
        if (!$this.hasClass('opened-menu')) { // #left-menu'de opened-menu class'i yoksa yapilacak olan islemler
            //console.log('açıldı');
            $this.addClass('opened-menu');
            $body.addClass('opened-body');
            $html.addClass('opened-body');
            $wrap.addClass('opened-wrap');
            $rndmenu.addClass('opened-rndmenu');
            $('#navusermenu').css("left", "0px");

            // sayfayı saga dogru kaydiriyoruz
            $wrap.animate({ "margin-left": "0" }, 400);

            // mobile menuyu aciyoruz
            $rndmenu.animate({ "margin-left": "0px" }, 400);

            // mobile overlayi aciyoruz
            $rndoverlay.animate({ "margin-left": "0" }, 400);

            // $('#prevPage').attr('style', 'margin-left: -34px;');
        }
        else { // #left-menu'de opened-menu class'i varsa yapilacak olan islemler
            //console.log('kapandı'); 
            closedMobileMenu();
        }
    });



    // submenuleri acma islemleri
    $('body').on('click', '.m-navigation a', function (e) {
        //e.stopPropagation();
        var $this = $(this);

        // tiklanan linkin parent li'sinde submenu class'i varsa yapilacak islemler
        if ($this.parent('li').hasClass('submenu')) {
            e.preventDefault();
            var $parentli = $this.parent('li.submenu');
            $parentli.find('.sublevel:first').animate({ "margin-left": "0px" }, 400);
        }
    });

    // acilan menu seviyesini kapatma(geriye gitme) islemi
    $('body').on('click', '.m-back', function () {
        var $this = $(this);
        var $parent = $this.parent().parent('.sublevel');
        $parent.animate({ "margin-left": "-100%" }, 400);
    });

    $('body').on('click', '#closeMenu', function () {
        closedMobileMenu();
    });


    // bu islemleri mobile menu acikken desktop gorunumune gecildiginde sifirlamak icin yapiyoruz
    $(window).resize(function () {
        if ($(window).width() > 1024) {
            winResizeMobileNav();
        }
    });

    // mobile menu acikken onun disinda bir yere tiklandiginda yapilacak islemler
    $(document).bind(mevent, function (e) {
        var target = e.target;
        // tiklanan #rnd-mobile-menu degilse - #rnd-mobile-menu'nun altindakiler degilse - #left-menu degilse - #rnd-mobile-overlay ise
        if (!$(target).is('#rnd-mobile-menu') && !$(target).is('#rnd-mobile-menu *') && !$(target).is('#left-menu')) {
            closedMobileMenu();
        }


        //console.log("Şuraya tıklandı: " + e.target.nodeName);
    });


});

// window resize oldugunda yapicalacak islemler
function winResizeMobileNav() {

    // body'e ekledigimiz ozellikleri kaldirdik
    if ($('body').hasClass('opened-body')) {
        $('body').removeClass('opened-body');
    }

    // #wrap divine ekledigimiz ozellikleri kaldirdik
    if ($('#wrap').hasClass('opened-wrap')) {
        $('#wrap').removeClass('opened-wrap');
        $('#wrap').css({ 'margin-left': '0px' });
    }

    // #left-menu divine ekledigimiz ozellikleri kaldirdik
    if ($('#left-menu').hasClass('opened-menu')) {
        $('#left-menu').removeClass('opened-menu');
    }

    // #rnd-mobile-menu divine ekledigimiz ozellikleri kaldirdik
    if ($('#rnd-mobile-menu').hasClass('opened-rndmenu')) {
        $('#rnd-mobile-menu').removeClass('opened-rndmenu');
    }

    // mobile overlayi kapatiyoruz
    $('#rnd-mobile-overlay').animate({ "margin-left": "-100%" }, 400);

    // acik olan submenuleri kapattik
    $('.sublevel').each(function () {
        $(this).animate({ "margin-left": -500 * $(this).parents("ul").length }, 400);
    });
}

// mobile menu kapatma islemleri
function closedMobileMenu() {

    // mobile menuyu kapatiyoruz
    $('#rnd-mobile-menu').animate({ "margin-left": "-100%" }, 400);

    // mobile overlayi kapatiyoruz
    $('#rnd-mobile-overlay').animate({ "margin-left": "-100%" }, 400);
    $('#navusermenu').css("left", "-100%");
    // sayfayi sola dogru kaydiriyoruz
    $('#wrap').animate({
        "margin-left": "0px"
    }, 400, function () {
        // animate tamamlandiginda class'lari kaldirdik
        $('#left-menu').removeClass('opened-menu');
        $('body').removeClass('opened-body');
        $('html').removeClass('opened-body');
        $('#wrap').removeClass('opened-wrap');
        $('#rnd-mobile-menu').removeClass('opened-rndmenu');
    });

//    $('#prevPage').each(function () {
//        this.style.setProperty('display', 'none', 'important');
//    });

    // acik olan submenuleri kapattik
    $('.sublevel').each(function () {
        $(this).animate({ "margin-left": -270 * $(this).parents("ul").length }, 400);
    });

//    if (window.location.pathname != "/") {
//        $('#prevPage').attr('style', '');
//    }

}


function pageup() {
    $("html, body").animate({
        scrollTop: 0
    }, 700, function () {
        return false;
    });
}